import { Component, OnInit } from '@angular/core';
import { LapsedPoliciesHandler } from './lapsed-policies.handler';
import { NotificationService } from '../services/notifications.service';
import { HeaderService } from 'src/app/system-common/services/header.service';
import { Router } from '@angular/router';
import { SettingService } from 'src/app/system-common/services/setting.service';
import { OfflineService } from 'src/app/offline/offline.service';
import { PolicyDetailsService } from 'src/app/policydetails/services/policydetails.service';

@Component({
  selector: 'sym-lapsed-policies',
  templateUrl: './lapsed-policies.component.html',
  styleUrls: ['./lapsed-policies.component.scss'],
})
export class LapsedPoliciesComponent extends LapsedPoliciesHandler implements OnInit {
  constructor(
    public service: NotificationService,
    public headerService: HeaderService,
    public router: Router,
    public settingService: SettingService
  ) {
    super(service, headerService, router, settingService);
  }

  ngOnInit() {
    super.ngOnInit();
  }
}
